<div class="h-full flex flex-col gap-3 pr-2 overflow-y-auto">

  <!-- Selected Client / Selected Project Header Card -->
  <app-project-header-card></app-project-header-card>


  <!-- ========================================================= -->
  <!-- INVOICE DETAILS -->
  <!-- ========================================================= -->

  <div class="formSection rounded-md p-4 flex flex-col gap-4">

    <div class="invoice-section-title">
      Invoice Details
    </div>

    <form [formGroup]="invoiceForm" class="flex flex-col gap-4 w-full">

      <!-- ===================================================== -->
      <!-- ROW 1 -->
      <!-- Invoice Description | Invoice Format | Free Format -->
      <!-- ===================================================== -->

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 px-1 items-center">

        <!-- Invoice Description -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-6 field-box">
          <input
            type="text"
            formControlName="invoiceDescription"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Invoice Description <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Invoice Format -->
        <!-- Invoice Format -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 select-box">

          <label class="select-label">
            Select an Invoice Format
            <span class="text-red-500">*</span>
          </label>

          <ng-select
            [items]="invoiceFormatsList"
            formControlName="invoiceFormat"
            placeholder=""
            class="invoice-select">
          </ng-select>

        </div>

        <!-- Free Format Description -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="text"
            formControlName="freeFormatDescription"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Free Format Description
            <span class="text-red-500" *ngIf="invoiceForm.get('invoiceFormat')?.value === 'Free Format'">*</span>
          </span>
        </div>

      </div>


      <!-- ===================================================== -->
      <!-- ROW 2 -->
      <!-- Hourly Rate | Hourly Breakdown | Discount | Tax -->
      <!-- ===================================================== -->

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 px-1 items-center">

        <!-- Project Hourly Rate -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-4 field-box">
          <input
            type="number"
            formControlName="projectHourlyRate"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
            min="0"
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Project Hourly Rate: {{ currencyLabel }} <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Show Hourly Breakdown -->
        <div class="flex items-center gap-2 h-9 col-span-12 md:col-span-2">
          <label class="text-xs text-gray-700">
            Show Hourly Breakdown
          </label>
          <input
            type="checkbox"
            id="shbCheck"
            formControlName="showHourlyBreakdown"
            class="h-4 w-4"
          />
        </div>

        <!-- Project Discount -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="number"
            formControlName="projectDiscount"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
            min="0"
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Project Discount (%) <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Local Sales Tax / VAT / GST -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="number"
            formControlName="salesTax"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
            min="0"
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            {{ taxTypeLabel }} <span class="text-red-500">*</span>
          </span>
        </div>

      </div>


      <!-- ===================================================== -->
      <!-- ROW 3 -->
      <!-- PO | Invoice Contact | Invoice Contact Address -->
      <!-- ===================================================== -->

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 px-1 items-center">

        <!-- Purchase Order Numbers -->
        <!-- Purchase Order Numbers -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 select-box">

          <label class="select-label">
            Purchase Order Numbers
          </label>

          <ng-select
            [items]="purchaseOrderList"
            formControlName="purchaseOrderNoViewMode"
            placeholder=""
            class="invoice-select"
            (change)="onPurchaseOrderChange($event)">
          </ng-select>

        </div>

        <!-- Invoice Contact -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="text"
            formControlName="invoiceContact"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Invoice Contact <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Invoice Contact Address -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-6 address-box">

          <span class="address-label">
            Invoice Contact Address
            <span class="text-red-500">*</span>
          </span>

          <textarea
            formControlName="invoiceContactAddress"
            class="address-textarea"
            placeholder="">
          </textarea>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- ROW 4 -->
      <!-- Charge + No VAT | Client VAT | CNPJ | Type Service -->
      <!-- ===================================================== -->

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 px-1 items-center">

        <!-- Charge + No VAT -->
        <div class="flex items-center gap-8 h-9 col-span-12 md:col-span-3">
          <div class="flex items-center gap-2">
            <label class="text-xs text-gray-700">Charge</label>
            <input
              type="checkbox"
              id="chargeCheck"
              formControlName="charge"
              class="h-4 w-4"
            />
          </div>

          <div class="flex items-center gap-2">
            <label class="text-xs text-gray-700">No VAT</label>
            <input
              type="checkbox"
              id="noVatCheck"
              formControlName="noVat"
              class="h-4 w-4"
            />
          </div>
        </div>

        <!-- Client VAT No -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="text"
            formControlName="clientVatNo"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Client VAT No
          </span>
        </div>

        <!-- CNPJ -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="text"
            formControlName="cnpj"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            CNPJ
          </span>
        </div>

        <!-- Type of Service -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 select-box">

          <label class="select-label">
            Select a Type of Service
          </label>

          <ng-select
            [items]="typesOfServiceList"
            formControlName="typeOfService"
            placeholder=""
            class="invoice-select">
          </ng-select>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- ACTION BUTTONS -->
      <!-- ===================================================== -->

      <div class="flex flex-row gap-3 mt-2 items-center">
        <button
          mat-raised-button
          type="button"
          [disabled]="invoiceForm.invalid"
          class="submit-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4"
          (click)="onSubmitInvoice()"
        >
          <div class="flex items-center gap-2">
            <mat-icon>save</mat-icon>
            <span>Submit</span>
          </div>
        </button>

        <button
          mat-raised-button
          type="button"
          class="delete-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4"
          (click)="onClearInvoice()"
        >
          <div class="flex items-center gap-2">
            <mat-icon>clear</mat-icon>
            <span>Clear</span>
          </div>
        </button>
      </div>

    </form>

  </div>


  <!-- ========================================================= -->
  <!-- PREPAYMENT DETAILS -->
  <!-- ========================================================= -->

  <div class="formSection rounded-md p-4 flex flex-col gap-4">

    <div class="invoice-section-title">
      Prepayment Details
    </div>

    <form [formGroup]="prepaymentForm" class="flex flex-col gap-4 w-full">

      <!-- ===================================================== -->
      <!-- ROW 1 -->
      <!-- PO | Reference | Amount | Date -->
      <!-- ===================================================== -->

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 px-1 items-center">

        <!-- Purchase Order Number -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="text"
            formControlName="prepaymentPurchaseOrderNo"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
            readonly
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Purchase Order Number
          </span>
        </div>
        <!-- <p>
          DEBUG PO:
          {{ prepaymentForm.get('prepaymentPurchaseOrderNo')?.value }}
        </p> -->

        <!-- Reference Number -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="text"
            formControlName="referenceNo"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Reference Number <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Prepayment Amount -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box">
          <input
            type="number"
            formControlName="prepaymentAmt"
            class="input-field absolute left-0 top-0 w-full h-full bg-transparent"
            placeholder=" "
            min="0"
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Prepayment Amount <span class="text-red-500">*</span>
          </span>
        </div>

        <!-- Prepayment Date -->
        <div class="relative border-b border-gray-400 col-span-12 md:col-span-3 field-box date-box">
          <input
            matInput
            [matDatepicker]="prepDatePicker"
            readonly
            (click)="prepDatePicker.open()"
            formControlName="prepaymentDate"
            class="input-field absolute left-0 top-0 bg-transparent"
            placeholder=" "
          />
          <span class="floating-label absolute left-0 pointer-events-none">
            Prepayment Date <span class="text-red-500">*</span>
          </span>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="prepDatePicker"
            class="date-toggle"
          >
          </mat-datepicker-toggle>
          <mat-datepicker #prepDatePicker></mat-datepicker>
        </div>

      </div>


      <!-- ===================================================== -->
      <!-- ROW 2 - DESCRIPTION -->
      <!-- ===================================================== -->

      <div class="relative border-b border-gray-400 px-1 field-box">
        <textarea
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="2"
          formControlName="prepaymentDescription"
          placeholder=" "
          class="input-field address-textarea absolute left-0 top-0 w-full bg-transparent"
        ></textarea>
        <span class="floating-label absolute left-0 pointer-events-none">
          Description <span class="text-red-500">*</span>
        </span>
      </div>


      <!-- ===================================================== -->
      <!-- ACTION BUTTONS -->
      <!-- ===================================================== -->

      <div class="flex flex-row gap-3 mt-2 items-center">
        <button
          mat-raised-button
          type="button"
          [disabled]="prepaymentForm.invalid"
          class="submit-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4"
          (click)="onSubmitPrepayment()"
        >
          <div class="flex items-center gap-2">
            <mat-icon>add</mat-icon>
            <span>Submit</span>
          </div>
        </button>

        <button
          mat-raised-button
          type="button"
          class="delete-button flex items-center justify-center font-semibold rounded-md min-h-0 h-10 px-4"
          (click)="onOpenPrepaymentDialog()"
        >
          <div class="flex items-center gap-2">
            <mat-icon>remove_red_eye</mat-icon>
            <span>View</span>
          </div>
        </button>
      </div>

    </form>

  </div>

</div>